'use client';

import React from 'react';

import { cn } from '../../utils/cn';

import type { HTMLAttributes, ReactNode } from 'react';

export interface UzPageHeaderProps extends Omit<HTMLAttributes<HTMLDivElement>, 'title'> {
  title: ReactNode;
  description?: ReactNode;
  /** Breadcrumbs rendered above the title. */
  breadcrumbs?: ReactNode;
  /** Right-aligned actions (typically buttons). */
  actions?: ReactNode;
  /** Optional badge/status indicator rendered next to the title. */
  meta?: ReactNode;
}

/**
 * Standard top-of-page header. Used at the top of every detail page.
 */
export const UzPageHeader = ({
  title,
  description,
  breadcrumbs,
  actions,
  meta,
  className,
  ...rest
}: UzPageHeaderProps): React.JSX.Element => (
  <header className={cn('mb-6 space-y-2', className)} {...rest}>
    {breadcrumbs && <div className="text-sm">{breadcrumbs}</div>}
    <div className="flex flex-wrap items-start justify-between gap-4">
      <div className="space-y-1">
        <div className="flex items-center gap-3">
          <h1 className="font-heading text-2xl font-bold tracking-tight">{title}</h1>
          {meta && <div>{meta}</div>}
        </div>
        {description && <p className="text-muted-foreground text-sm">{description}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div>}
    </div>
  </header>
);
